import React from 'react';
import Icon from '../../../components/AppIcon';

const ModalHeader = ({ onClose }) => {
  return (
    <div className="flex items-center justify-between p-8 border-b border-border">
      <div className="space-y-2">
        <h1 className="text-3xl font-semibold text-foreground tracking-tight">
          Choose Your Path
        </h1>
        <p className="text-muted-foreground text-lg">
          Select how you'd like to use Workfolio to get started
        </p>
      </div>
      <button
        onClick={onClose}
        className="p-3 rounded-xl text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-all duration-200 hover:scale-105"
        aria-label="Close role selection modal"
      >
        <Icon name="X" size={28} />
      </button>
    </div>
  );
};

export default ModalHeader;